export default {
  uri: 'https://profits.wicon.io/apis',
  version: '1.1.0',
}
